/* Blue Hour storefront behaviour. Ported from the approved mockup (visual/visual.js):
   same menu intent timings (350ms open / 180ms close on fine pointers), click-to-open,
   Escape returns focus to the trigger, outside click / focus closes, native <dialog> phone
   menu with scroll lock and focus return. Commerce uses Shopify's own endpoints. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const shop = window.bhShop || { root: '/', cartUrl: '/cart', cartAddUrl: '/cart/add', cartChangeUrl: '/cart/change' };
  const announce = message => { const el = $('#bh-announcement'); if (el) el.textContent = message; const visible = $('#bh-shop-message'); if (visible) visible.textContent = message; };

  /* ---------- desktop department menus ---------- */
  const menu = { open: null, hoverTimer: 0, closeTimer: 0 };
  function closeMenu(returnFocus = false) {
    clearTimeout(menu.hoverTimer); clearTimeout(menu.closeTimer);
    const old = menu.open; menu.open = null;
    $$('.bh-nav-panel').forEach(panel => { panel.hidden = true; });
    $$('[data-toggle-menu]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (returnFocus && old) $(`[data-toggle-menu="${old}"]`)?.focus();
  }
  function openMenu(id) {
    closeMenu();
    const panel = document.getElementById(`bh-submenu-${id}`), button = $(`[data-toggle-menu="${id}"]`);
    if (!panel || !button) return;
    menu.open = id; panel.hidden = false; button.setAttribute('aria-expanded', 'true');
  }
  $$('[data-nav-group]').forEach(group => {
    group.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      clearTimeout(menu.closeTimer);
      menu.hoverTimer = setTimeout(() => openMenu(group.dataset.navGroup), 350);
    });
    group.addEventListener('pointerleave', () => {
      clearTimeout(menu.hoverTimer);
      menu.closeTimer = setTimeout(() => { if (!group.contains(document.activeElement)) closeMenu(); }, 180);
    });
  });

  /* ---------- phone menu dialog ---------- */
  const dialog = $('#bh-mobile-menu');
  let mobileReturnFocus = false;
  function closeMobile(returnFocus = true) {
    if (dialog?.open) { mobileReturnFocus = returnFocus; dialog.close(); }
    document.body.classList.remove('bh-modal-open');
  }
  dialog?.addEventListener('close', () => {
    document.body.classList.remove('bh-modal-open');
    if (mobileReturnFocus) $('[data-open-mobile]')?.focus({ preventScroll: true });
  });

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-toggle-menu]');
    if (toggle) { const id = toggle.dataset.toggleMenu; menu.open === id ? closeMenu() : openMenu(id); return; }
    if (event.target.closest('[data-open-mobile]')) {
      closeMenu(); mobileReturnFocus = true;
      dialog?.showModal(); document.body.classList.add('bh-modal-open');
      dialog?.querySelector('[data-close]')?.focus();
      return;
    }
    if (event.target.closest('[data-close]')) { closeMobile(); return; }
    if (event.target.closest('#bh-mobile-links a')) closeMobile(false);
    if (!event.target.closest('.bh-nav-group')) closeMenu();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) { event.preventDefault(); closeMenu(true); }
  });
  document.addEventListener('focusin', event => {
    if (menu.open && !event.target.closest(`[data-nav-group="${menu.open}"]`)) closeMenu();
  });

  /* ---------- Saved pieces (this device) ---------- */
  const SAVED_KEY = 'bh-saved';
  const readSaved = () => { try { const v = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch { return []; } };
  const writeSaved = list => { try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); return true; } catch { return false; } };
  const isSaved = variant => readSaved().some(item => String(item.variant) === String(variant));
  function syncSaved() {
    const count = $('[data-saved-count]');
    if (count) count.textContent = `Saved (${readSaved().length})`;
    $$('[data-save]').forEach(button => {
      const saved = isSaved(button.dataset.variant);
      button.setAttribute('aria-pressed', String(saved));
      const label = button.dataset.label || '';
      button.setAttribute('aria-label', `${saved ? 'Unsave' : 'Save'} ${label}`.trim());
      button.textContent = saved ? 'Saved Piece' : 'Save This Option';
    });
  }
  function toggleSaved(button) {
    const variant = String(button.dataset.variant), handle = button.dataset.save;
    let list = readSaved();
    const exists = list.some(item => String(item.variant) === variant);
    list = exists ? list.filter(item => String(item.variant) !== variant) : [...list, { handle, variant, savedAt: Date.now() }];
    if (!writeSaved(list)) { announce('This browser cannot keep saved pieces.'); return; }
    syncSaved();
    announce(exists ? 'Selected option removed from saved pieces.' : 'Selected option saved on this device.');
    document.dispatchEvent(new CustomEvent('bh:saved-changed'));
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-save]');
    if (button) { event.preventDefault(); toggleSaved(button); }
  });
  window.bhSaved = { read: readSaved, write: writeSaved, sync: syncSaved };

  /* ---------- Bag count ---------- */
  function setBagCount(count) { const el = $('[data-bag-count]'); if (el) el.textContent = `Bag (${count})`; }
  window.bhBag = { setCount: setBagCount };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const format = shop.moneyFormat || '${{amount}}';
    const value = Number(cents) / 100;
    const withDelims = (n, d = 2, t = ',', dec = '.') => {
      const [whole, frac] = n.toFixed(d).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? dec + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: withDelims(value), amount_no_decimals: withDelims(value, 0),
      amount_with_comma_separator: withDelims(value, 2, '.', ','), amount_no_decimals_with_comma_separator: withDelims(value, 0, '.', ',')
    })[key] ?? withDelims(value));
  }
  window.bhMoney = formatMoney;

  /* ---------- product page: gallery, exact option, add to bag ---------- */
  const productRoot = $('[data-product-root]');
  if (productRoot) {
    const main = $('.bh-pdp-hero', productRoot);
    const showImage = (src, srcset, width, height) => {
      if (!main || !src) return;
      main.removeAttribute('srcset');
      if (width) main.width = width; if (height) main.height = height;
      main.src = src; if (srcset) main.srcset = srcset;
    };
    productRoot.addEventListener('click', event => {
      const thumb = event.target.closest('.bh-gallery-thumb');
      if (!thumb) return;
      showImage(thumb.dataset.gallery, thumb.dataset.gallerySrcset, thumb.dataset.width, thumb.dataset.height);
      $$('.bh-gallery-thumb', productRoot).forEach(b => b.setAttribute('aria-pressed', String(b === thumb)));
    });

    let product = null;
    try { product = JSON.parse($('[data-product-json]', productRoot)?.textContent || 'null'); } catch { product = null; }
    const select = $('[data-variant-select]', productRoot);
    const optionName = v => (/^Default( Title)?$/.test(v.title) ? 'Standard Option' : v.title);
    select?.addEventListener('change', () => {
      const v = product?.variants?.find(x => String(x.id) === select.value);
      if (!v) return;
      const price = $('[data-price]', productRoot); if (price) price.textContent = formatMoney(v.price);
      const avail = $('[data-availability]', productRoot);
      if (avail) avail.textContent = v.available ? 'Available to order. Shipping is calculated at checkout.' : 'This option is currently unavailable.';
      const add = $('[data-add-button]', productRoot);
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to Bag' : 'Unavailable'; }
      const size = $('[data-size-from-variant]', productRoot);
      if (size) size.textContent = /^Default( Title)?$/.test(v.title) ? 'See product details' : v.title;
      const save = $('[data-save]', productRoot);
      if (save) { save.dataset.variant = String(v.id); save.dataset.label = `${product.title} · ${optionName(v)}`; }
      syncSaved();
      if (v.featured_image?.src) showImage(v.featured_image.src, '', v.featured_image.width, v.featured_image.height);
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    });

    const form = $('[data-product-form]', productRoot);
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      const add = $('[data-add-button]', productRoot);
      if (add?.disabled) return;
      if (add) { add.disabled = true; add.textContent = 'Adding…'; }
      try {
        const res = await fetch(`${shop.cartAddUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data?.description || data?.message || 'The add request did not complete.');
        announce('Added the selected option to your bag.');
        location.href = shop.cartUrl;
      } catch (error) {
        announce(`That piece was not added. ${error.message} Your selected option is unchanged.`);
        if (add) { add.disabled = false; add.textContent = 'Add to Bag'; }
      }
    });
  }

  /* ---------- bag: quantity, remove, undo (Shopify cart) ---------- */
  const cartForm = $('[data-cart-form]');
  const UNDO_KEY = 'bh-cart-undo';
  async function changeLine(line, quantity) {
    const res = await fetch(`${shop.cartChangeUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity }) });
    if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.description || d.message || 'The bag could not be updated.'); }
    return res.json();
  }
  if (cartForm) {
    cartForm.addEventListener('change', async event => {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) { input.setAttribute('aria-invalid', 'true'); announce('Enter a quantity from 1 to 99.'); return; }
      input.removeAttribute('aria-invalid');
      try { await changeLine(input.dataset.cartQuantity, quantity); location.reload(); }
      catch (error) { announce(error.message); }
    });
    cartForm.addEventListener('click', async event => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      const row = remove.closest('[data-line]');
      try { sessionStorage.setItem(UNDO_KEY, JSON.stringify({ id: row.dataset.variantId, quantity: Number(row.dataset.quantity) || 1 })); } catch { /* undo unavailable */ }
      try { await changeLine(remove.dataset.cartRemove, 0); location.reload(); }
      catch (error) { announce(error.message); }
    });
  }
  const undoBox = $('[data-cart-undo]');
  if (undoBox) {
    let pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(UNDO_KEY) || 'null'); sessionStorage.removeItem(UNDO_KEY); } catch { pending = null; }
    if (pending) { undoBox.hidden = false; announce('Item removed. Undo is available.'); }
    undoBox.addEventListener('click', async event => {
      if (!event.target.closest('[data-cart-undo-button]') || !pending) return;
      try {
        const res = await fetch(`${shop.cartAddUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(pending.id), quantity: pending.quantity }] }) });
        if (!res.ok) throw new Error('The item could not be restored.');
        location.reload();
      } catch (error) { announce(error.message); }
    });
  }

  /* ---------- small DOM builder (no innerHTML) ---------- */
  function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [key, value] of Object.entries(attrs)) {
      if (value == null || value === false) continue;
      if (key === 'text') node.textContent = value; else node.setAttribute(key, value);
    }
    for (const child of [].concat(children)) if (child) node.append(child);
    return node;
  }
  const imgUrl = (src, width) => {
    if (!src) return '';
    const abs = src.replace(/^\/\//, 'https://');
    return `${abs}${abs.includes('?') ? '&' : '?'}width=${width}`;
  };

  /* ---------- Saved page: render the device shortlist ---------- */
  const savedList = $('[data-saved-list]');
  const productCache = new Map();
  function productData(handle) {
    if (!productCache.has(handle)) productCache.set(handle, fetch(`${shop.root}products/${encodeURIComponent(handle)}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null));
    return productCache.get(handle);
  }
  let lastRemoved = null;
  function savedCard(item, p, v) {
    if (!p || !v) {
      return el('article', { class: 'bh-product-card' }, [
        el('h3', { text: 'This saved option is no longer available' }),
        el('p', { class: 'bh-small-print', text: 'No other product or option has been substituted.' }),
        el('button', { type: 'button', 'data-remove-saved': String(item.variant), text: 'Remove Saved Option' })
      ]);
    }
    const option = /^Default( Title)?$/.test(v.title) ? 'Standard Option' : v.title;
    const ships = p.variants.some(x => x.requires_shipping);
    const src = imgUrl(v.featured_image?.src || p.featured_image, 600);
    const link = el('a', { href: `${p.url}?variant=${v.id}` }, [
      el('div', { class: 'bh-card-image' }, src ? el('img', { src, alt: p.title, width: '600', height: '600', loading: 'lazy' }) : null),
      el('h3', { text: p.title }),
      ships ? null : el('p', { class: 'bh-product-kind', text: 'Digital download — not a finished item' }),
      el('p', { text: `${option} · ${formatMoney(v.price)}` }),
      el('p', { class: 'bh-small-print', text: v.available ? 'Available to order.' : 'This option is currently unavailable.' })
    ]);
    return el('article', { class: 'bh-product-card' }, [
      link,
      el('button', { type: 'button', 'data-remove-saved': String(v.id), 'aria-label': `Remove saved ${p.title} · ${option}`, text: 'Remove Saved Option' })
    ]);
  }
  async function renderSaved() {
    if (!savedList) return;
    const list = readSaved();
    const empty = $('[data-saved-empty]');
    if (empty) empty.hidden = list.length > 0;
    const cards = await Promise.all(list.map(async item => {
      const p = await productData(item.handle);
      const v = p?.variants?.find(x => String(x.id) === String(item.variant));
      return savedCard(item, p, v);
    }));
    savedList.replaceChildren(...cards);
  }
  if (savedList) {
    renderSaved();
    savedList.addEventListener('click', event => {
      const button = event.target.closest('[data-remove-saved]');
      if (!button) return;
      const list = readSaved();
      lastRemoved = list.find(item => String(item.variant) === button.dataset.removeSaved) || null;
      writeSaved(list.filter(item => String(item.variant) !== button.dataset.removeSaved));
      syncSaved(); renderSaved();
      const undo = $('[data-saved-undo]'); if (undo && lastRemoved) undo.hidden = false;
      announce('Saved option removed. Undo is available.');
    });
    $('[data-saved-undo]')?.addEventListener('click', event => {
      if (!event.target.closest('[data-saved-undo-button]') || !lastRemoved) return;
      writeSaved([...readSaved(), lastRemoved]); lastRemoved = null;
      $('[data-saved-undo]').hidden = true; syncSaved(); renderSaved();
      announce('Saved option restored.');
    });
  }

  /* ---------- help / delivery: carry the product forward ---------- */
  const params = new URLSearchParams(location.search);
  const prefill = $('[data-prefill-product]');
  if (prefill && !prefill.value && params.get('product')) prefill.value = params.get('product').slice(0, 200);
  const contextBox = $('[data-context-piece]');
  if (contextBox && params.get('product')) {
    productData(params.get('product')).then(p => {
      if (!p) return;
      const src = imgUrl(p.featured_image, 300);
      contextBox.replaceChildren(
        src ? el('img', { src, alt: '', width: '110', height: '110' }) : '',
        el('div', {}, [el('h2', { text: p.title }), el('p', { text: `From ${formatMoney(p.price)}` })])
      );
      contextBox.hidden = false;
      const ask = $('[data-context-ask]');
      if (ask) { ask.href = `${shop.root}pages/contact?product=${encodeURIComponent(p.title)}`; ask.textContent = 'Ask a Question About This Item'; }
    });
  }

  syncSaved();

  // Audit fix 2026-09-28: collection sort and price apply as soon as they change (the Apply Sort button remains for
  // visitors without JavaScript; CSS hides it once this script runs).
  document.addEventListener('change', event => {
    const el = event.target;
    if (el && (el.id === 'bh-collection-sort' || el.id === 'bh-collection-price') && el.form) el.form.submit();
  });
})();
